/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import DriveEnum from './drive-enum';

/**
 * Utility pro práci s úložnými jednotkami.
 */
class DriveUtil {
  /**
   * Nalezne jednotku k uložení obsahu.
   * Zatím vždy vybere interní jednotku, u které očekává, že bude jediná přítomná tohoto typu.
   * Dočasná náhrada před implementací pokročilejšího výběru vhodných jednotek.
   * @param {Array.<DriveUnit>} driveUnitArray Seznam úložných jednotek.
   * @returns {DriveUnit|null} Nalezená primární jednotka.
   */
  static find(driveUnitArray) {
    const externalDriveUnitArray = [];
    const internalDriveUnitArray = [];
    driveUnitArray.forEach((driveUnit) => {
      switch (driveUnit.driveEnum) {
        case DriveEnum.EXTERNAL:
          externalDriveUnitArray.push(driveUnit);
          break;
        case DriveEnum.INTERNAL:
          internalDriveUnitArray.push(driveUnit);
          break;
        default:
          throw new RangeError(`Unknown drive unit "${driveUnit}".`);
      }
    });
    switch (internalDriveUnitArray.length) {
      case 0:
        if (externalDriveUnitArray.length === 1) {
          return externalDriveUnitArray[0];
        }
        return null;
      case 1:
        return internalDriveUnitArray[0];
      default:
        return null;
    }
  }
}

export default DriveUtil;
